import React, { useContext, useState } from "react";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import mtsLogo from "assets/images/mts-logo.png";
import { Box, Button, Grid, Stack } from "@mui/material";
import Dropdown from "components/common/dropdownButton/DropdownButton";
import UserContext from "context/userContext/UserContext";
import NotificationWindow from "components/module/app/notification/Notification";
import CourseTimelineCard from "components/module/app/courseChapter/CourseTimelineCard";
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, IconButton, Divider } from '@mui/material';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { userData } = useContext(UserContext); // Access UserContext
  const location = useLocation();

  // Handle navigation
  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const showMenuIcon = matchPath("app/course/:chapter/learn/:lesson", location.pathname);
  // Conditionally render Navbar or Create Account Button
  return (
    <>
    <AppBar className="appbar-navbar">
      <Container maxWidth="xl">
        <Toolbar disableGutters className="appbar-toolbar-navbar">
          {/* Hamburger Menu Icon for Mobile */}
          {showMenuIcon && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ display: { xs: 'block', md: 'none' }, color: 'black'  }}
          >
            <MenuIcon />
          </IconButton>
          )}

          {/* Center the logo on mobile by adjusting flex properties */}
          <Link to="/app/dashboard" className="navbar-logo-wrapper">
            <Box
              component="img"
              src={mtsLogo}
              alt="MTS logo"
              className="navbar-logo"
              sx={{
                margin: { xs: '0 auto', md: 'unset' },
                display: { xs: 'block', md: 'inline-block' },
              }}
            />
          </Link>

          {userData && userData.length > 0 ? (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              className="navbar-buttons"
              sx={{ flexGrow: 1, justifyContent: 'flex-end' }}
            >
              <Button
                className="dashboard text"
                onClick={() => handleNavigation("dashboard")}
              >
                Dashboard
              </Button>
              <Button
                className="courses text"
                onClick={() => handleNavigation("my-course")}
              >
                Courses
              </Button>
              <NotificationWindow />
              <Dropdown />
            </Stack>
          ) : (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              className="navbar-buttons"
              sx={{ flexGrow: 1, justifyContent: 'flex-end' }}
            >
              <Button
                className="courses text"
                onClick={() => handleNavigation("courses")}
              >
                Courses
              </Button>
              <Button
                className="courses text"
                onClick={() => handleNavigation("login")}
              >
                Login
              </Button>
              <Button
                className="dropdown__button capitalize"
                onClick={() => handleNavigation("/create-account")}
              >
                Create Account
              </Button>
            </Stack>
          )}
        </Toolbar>
      </Container>
    </AppBar>

    {/* Sidebar Drawer for Mobile View */}
    <Drawer
  anchor="left"
  open={mobileOpen}
  onClose={handleDrawerToggle}
  disablePortal  // Prevents mounting in the DOM's body
  sx={{
    display: { xs: 'block', md: 'none' },
    '& .MuiDrawer-paper': { width: 250,padding: 2 },
  }}
>

      <CourseTimelineCard />
      <Divider />
    </Drawer>

  </>
  );
};

export default Navbar;
